import * as React from 'react';
import { Fragment, useEffect, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import ImageSource from '@th/shared/src/types/ImageSource';
import ListingImagesSingleImageFullScreenModalHeader from './ListingImagesSingleImageFullScreenModalHeader';
import ListingImagesSingleImageFullScreenModalCarousel from './ListingImagesSingleImageFullScreenModalCarousel';
import useWindowDimensions from '../../../hooks/useWindowDimensions';

type Props = {
  imageUrls: Array<ImageSource>;
  isOpen: boolean;
  onClose: () => void;
  initialImageIndex: number;
};

export default function ListingImagesSingleImageFullScreenModal({
  imageUrls,
  isOpen,
  onClose,
  initialImageIndex,
}: Props) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { isMobile } = useWindowDimensions();

  useEffect(() => {
    setCurrentIndex(initialImageIndex);
  }, [initialImageIndex]);

  const numImages = imageUrls.length;

  function showPreviousImage() {
    setCurrentIndex(prevValue =>
      prevValue === 0 ? numImages - 1 : prevValue - 1,
    );
  }

  function showNextImage() {
    setCurrentIndex(prevValue =>
      prevValue === numImages - 1 ? 0 : prevValue + 1,
    );
  }

  function updateCurrentIndex(index: number) {
    setCurrentIndex(index);
  }

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-30"
        onClose={onClose}
        initialFocus={null}
      >
        <div className="fixed inset-0 z-30">
          <div className="flex min-h-full justify-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative flex flex-1 flex-col bg-black transition-all h-screen w-screen sm:p-6">
                <ListingImagesSingleImageFullScreenModalHeader
                  currentIndex={currentIndex}
                  numImages={numImages}
                  onClose={onClose}
                />
                <ListingImagesSingleImageFullScreenModalCarousel
                  imageUrls={imageUrls}
                  currentIndex={currentIndex}
                  numImages={numImages}
                  showPreviousImage={showPreviousImage}
                  showNextImage={showNextImage}
                  updateCurrentIndex={updateCurrentIndex}
                />
                {/* This is a hack to add a hidden "footer" that matches the header height exactly, to balance the carousel to be in the centre of the screen on mobile devices */}
                <ListingImagesSingleImageFullScreenModalHeader
                  invisible={true}
                  currentIndex={0}
                  numImages={0}
                  onClose={() => {}}
                />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
